import { render, staticRenderFns } from "./MarketplaceActivity.vue?vue&type=template&id=09d0e5a9&scoped=true&"
import script from "./MarketplaceActivity.vue?vue&type=script&lang=js&"
export * from "./MarketplaceActivity.vue?vue&type=script&lang=js&"
import style0 from "../../less/complex.less?vue&type=style&index=0&id=09d0e5a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d0e5a9",
  null
  
)

export default component.exports